import { render, staticRenderFns } from "./LeaveChannel.html?vue&type=template&id=08a1e5ce&scoped=true&"
import script from "./LeaveChannel.js?vue&type=script&lang=js&"
export * from "./LeaveChannel.js?vue&type=script&lang=js&"
import style0 from "./LeaveChannel.scss?vue&type=style&index=0&id=08a1e5ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a1e5ce",
  null
  
)

export default component.exports